/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React from "react";
import { Button, Alert } from "antd";
import { useCookieConsent } from "../CookieConsentContext";

const CookieConsent = () => {
  const { cookiesAccepted, setCookiesAccepted } = useCookieConsent();

  if (cookiesAccepted !== null) {
    return null;
  }

  return (
    <div style={{ position: "fixed", bottom: 0, width: "100%", zIndex: 1000 }}>
      <Alert
        message="Usamos cookies para mejorar tu experiencia. ¿Aceptas el uso de cookies?"
        type="info"
        action={
          <>
            <Button onClick={() => setCookiesAccepted(true)} type="primary">
              Aceptar
            </Button>
            <Button
              onClick={() => setCookiesAccepted(false)}
              style={{ marginLeft: 8 }}
            >
              Rechazar
            </Button>
          </>
        }
        closable={false}
      />
    </div>
  );
};

export default CookieConsent;
